import Pica from 'pica';
import * as orderImageService from 'services/orderImageService';

export async function uploadFiles(
  fileUploads: Array<{ file: File; progress: number; controller: AbortController }>,
  orderId: number,
  onProgress: (percentCompleted: number, i: number) => void
): Promise<void> {
  await Promise.allSettled(
    fileUploads.map(
      async (f, i) =>
        await orderImageService.uploadOrderImageAsync(orderId, f.file, {
          onUploadProgress: (e) => {
            const percentCompleted = Math.round((e.progress ?? 0) * 100);

            onProgress(percentCompleted, i);
          },
          signal: f.controller.signal,
        })
    )
  );
}

export async function resizeImage(
  file: File,
  pica: Pica.Pica,
  maxWidth: number,
  maxHeight: number
): Promise<File> {
  return await new Promise<File>((resolve, _reject) => {
    const img = new Image();
    img.onload = async () => {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      if (width <= maxWidth && height <= maxHeight) {
        resolve(file);
        return;
      }

      if (width > maxWidth) {
        height *= maxWidth / width;
        width = maxWidth;
      }
      if (height > maxHeight) {
        width *= maxHeight / height;
        height = maxHeight;
      }

      canvas.width = width;
      canvas.height = height;

      await pica.resize(img, canvas);

      canvas.toBlob((blob) => {
        const resizedFile = new File([blob as Blob], file.name, { type: file.type });

        resolve(resizedFile);
      }, file.type);
    };

    img.src = URL.createObjectURL(file);
  });
}

export async function resizeImages(files: File[]): Promise<File[]> {
  const pica = new Pica();

  const resizedFiles: File[] = [];

  for (const file of files) {
    try {
      const resizedFile = await resizeImage(file, pica, 1920, 1080);
      resizedFiles.push(resizedFile);
    } catch (error) {
      console.error('Error resizing image:', error);
    }
  }
  return resizedFiles;
}
